import React from "react";
import {Box, Text} from "@chakra-ui/react";

/** TimeBox's single navigation accent (matches .toolbar-slider in myjira.css) — reused here so the
 * ported toolbar reads as part of the app instead of a foreign widget with its own color language. */
export const BRAND_ACCENT = "#ec8e00";

type InfoBarTone = "context" | "warning";

interface InfoBarProps {
    tone?: InfoBarTone;
    children: React.ReactNode;
}

/** Single, neutral context/warning banner style shared by every WeekActions dialog. */
export function InfoBar({tone = "context", children}: InfoBarProps) {
    if (tone === "warning") {
        return (
            <Box bg="orange.50" _dark={{bg: "rgba(237, 137, 54, 0.12)"}} borderLeft="3px solid" borderColor="orange.400" borderRadius="md" p={3} mb={3} fontSize="sm">
                {children}
            </Box>
        );
    }
    return (
        <Box bg="surface-muted" borderLeft="3px solid" borderColor={BRAND_ACCENT} borderRadius="md" p={3} mb={3} fontSize="sm">
            {children}
        </Box>
    );
}

/** The AD NL / OSM absence-booking notice, shown verbatim in both Settings and Help. */
export function HolidayNotice() {
    return (
        <InfoBar tone="warning">
            <Text fontWeight={700} color="orange.800" _dark={{color: "orange.200"}}>For AD NL: do not register vacation in TimeBox</Text>
            <Text color="orange.900" _dark={{color: "orange.100"}}>
                Automatic holiday filling is disabled. All absence hours are booked in AllSolutions only.
                For OSM in Germany/USA please use NBP-14 to book absence hours.
            </Text>
        </InfoBar>
    );
}
